import request from '@/utils/request'

// 福来礼-订单确认信息
export function getFllOrderConfirmInfo(params) {
  return request({
    url: '/plat-web/fulaili/orderConfirmInfo',
    method: 'post',
    data: params,
    isPlatWeb: true
  })
}

// 福来礼-去支付
export function fllToPay(params) {
  return request({
    url: '/plat-web/fulaili/toPay',
    method: 'post',
    data: params,
    isPlatWeb: true
  })
}

// 福来礼-获取充值说明
export function getFllBusiDescription(type) {
  return request({
    url: '/plat-web/busiDescription/detail/' + type,
    method: 'post',
    isPlatWeb: true
  })
}

// 福来礼-订单详情
export function getFllOrderDetail(params) {
  return request({
    url: '/plat-web/fulaili/orderDetail',
    method: 'post',
    data: params,
    isPlatWeb: true
  })
}
